import { getHours, fromUnixTime } from 'date-fns';

export const defaultActiveState = {
  sessionType: null,
  discipline: null,
  product: null,
  activity: null,
  level: null,
  instructor: null,
  timePeriod: null,
  riderOverload: false,
  completeSessions: false,
  overbookedSessions: false
};

export default {
  namespaced: true,
  state: {
    active: { ...defaultActiveState },
    repriseTabSessionTypesToExclude: ['GOLF']
  },
  mutations: {
    setFilters (state, { key, value }) {
      state.active = { ...state.active, [key]: value };
    },
    resetFilters (state) {
      state.active = { ...defaultActiveState };
    }
  },
  getters: {
    byType: state => (sessions, typesToExclude = state.repriseTabSessionTypesToExclude) => {
      if (!typesToExclude || !typesToExclude.length) {
        return sessions;
      }
      if (state.active.sessionType) {
        return sessions.filter(session => session.type === state.active.sessionType);
      }
      return sessions.filter(session => !typesToExclude.includes(session.type));
    },
    byDiscipline: state => sessions => {
      if (!state.active.discipline) {
        return sessions;
      }
      return sessions.filter(session => session.discipline?.uuid === state.active.discipline);
    },
    byProduct: state => sessions => {
      if (!state.active.product) {
        return sessions;
      }
      return sessions.filter(session => (session.product_activity || []).some(pa => pa.product === state.active.product));
    },
    byActivity: state => sessions => {
      if (!state.active.activity) {
        return sessions;
      }
      return sessions.filter(session => (session.product_activity || []).some(pa => pa.activity === state.active.activity));
    },
    byLevel: state => sessions => {
      if (!state.active.level) {
        return sessions;
      }
      return sessions.filter(session => session.level === state.active.level);
    },
    byInstructor: state => sessions => {
      if (!state.active.instructor) {
        return sessions;
      }
      return sessions.filter(session => session.instructors.some(instructor => instructor.uuid === state.active.instructor));
    },
    byTimePeriod: state => sessions => {
      switch (state.active.timePeriod) {
        case 'morning':
          return sessions.filter(session => {
            const hourStart = getHours(fromUnixTime(session.start_time));

            return hourStart >= 8 && hourStart < 12;
          });
        case 'afternoon':
          return sessions.filter(session => {
            const hourStart = getHours(fromUnixTime(session.start_time));

            return hourStart >= 12 && hourStart < 18;
          });
        case 'evening':
          return sessions.filter(session => {
            const hourStart = getHours(fromUnixTime(session.start_time));

            return hourStart >= 18 && hourStart < 22;
          });
        default:
          return sessions;
      }
    },
    byRiderOverload: state => sessions => {
      if (!state.active.riderOverload) {
        return sessions;
      }
      return sessions.filter(session => (session.participants || []).length > (session.horses || []).length);
    },
    byCompleteSessions: state => sessions => {
      if (!state.active.completeSessions) {
        return sessions;
      }
      return sessions.filter(session => (session.participants || []).length === session.max_participant);
    },
    byOverbookedSessions: state => sessions => {
      if (!state.active.overbookedSessions) {
        return sessions;
      }
      return sessions.filter(session => (session.participants || []).length > session.max_participant);
    },
    repriseTab: (state, getters) => sessions => {
      if (!sessions || !sessions.length) return [];
      const pipeline = [getters.byType, getters.byDiscipline, getters.byProduct, getters.byActivity, getters.byLevel, getters.byInstructor, getters.byTimePeriod, getters.byRiderOverload, getters.byCompleteSessions, getters.byOverbookedSessions];

      return pipeline.reduce((acc, filter) => filter(acc), sessions);
    }
  }
};
